import * as changeCase from 'change-case'
import {
  PERMISSION_ACTION_ADD,
  PERMISSION_ACTION_APPROVE,
  PERMISSION_ACTION_COMPLETE,
  PERMISSION_ACTION_DELETE,
  PERMISSION_ACTION_DENY,
  PERMISSION_ACTION_EDIT,
  PERMISSION_ACTION_FUND,
  PERMISSION_ACTION_PUBLISH,
  PERMISSION_ACTION_ACCEPT,
  PERMISSION_ACTION_REJECT,
  PERMISSION_ACTION_VOID
} from '@klear/constants'

export function getPastTense(type: string) {
  switch (type) {
    case PERMISSION_ACTION_ADD:
      return 'created'
    case PERMISSION_ACTION_PUBLISH:
      return 'published'
    case PERMISSION_ACTION_FUND:
      return 'funded'
    case PERMISSION_ACTION_COMPLETE:
      return 'completed'
    case PERMISSION_ACTION_VOID:
      return 'voided'
    case PERMISSION_ACTION_ACCEPT:
      return 'accepted'
    case PERMISSION_ACTION_REJECT:
      return 'rejected'
    case PERMISSION_ACTION_APPROVE:
      return 'approved'
    case PERMISSION_ACTION_DENY:
      return 'denied'
    case PERMISSION_ACTION_DELETE:
      return 'deleted'
    case PERMISSION_ACTION_EDIT:
      return 'edited'
    default:
      return `${changeCase.noCase(type ?? '')}d`
  }
}
